<template>
  <div class="text-wings" :class="{'d-inline-flex': wings!=='both'}">
    <span v-if="wings==='both' || wings==='left'" class="left-wing" :style="{backgroundColor: color, height: height+'px', width: width}"></span>
    <div class="text" :style="[wings!=='both' ? wings==='left' ? {paddingLeft: distance + 'px'} : {paddingRight: distance + 'px'} : {paddingLeft: distance + 'px', paddingRight: distance + 'px'}]">
      <slot>PUT YOUR TITLE HERE</slot>
    </div>
    <span v-if="wings==='both' || wings==='right'" class="right-wing" :style="{backgroundColor: color, height: height+'px', width: width}"></span>
  </div>
</template>

<script>
  export default {
    props: {
      distance: {
        type: Number,
        required: false,
        default: 15
      },
      height: {
        type: Number,
        required: false,
        default: 1
      },
      width: {
        type: String,
        required: false,
        default: '100%'
      },
      color: {
        type: String,
        required: false,
        default: "currentColor"
      },
      wings: {
        type: String,
        required: false,
        default: "both"
      },
    },
  }
</script>

<style lang="scss">
  text-wings {
    text-align: center;
  }

  .text-wings {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    &.d-inline-flex {
      display: inline-flex;
    }

    .text {
      display: inline-block;
      white-space: nowrap;
    }

    .left-wing,
    .right-wing {
      display: block;
      width: 100%;
    }
  }
</style>